import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import PropTypes from "prop-types";

import "wxrecall/components/ImageInput.css";

/**
 * Renders a set of image product selection checkboxes. This component can render either
 * a single checkbox, or a recursive set of checkboxes, depending on the structure of
 * the data given. See DefaultStates.js for structure details.
 */
function ImageInput({ id, name, data, parent, onToggle }) {
  let text = (
    <FormattedMessage
      id={"alphaImage." + name}
      defaultMessage={"alphaImage." + name}
    />
  );
  if ("enabled" in data) {
    return (
      <div className={`image-input ${parent}-input`}>
        <label htmlFor={id + "-toggle"}>
          <input
            type="checkbox"
            id={id + "-toggle"}
            onChange={() => {
              onToggle(id);
            }}
            checked={data.enabled}
          />
          {text}
        </label>
      </div>
    );
  } else {
    let parent = id;
    return (
      <div className={`image-input ${name.toLowerCase()}-parent`}>
        <span className="parent">{text}</span>
        <div>
          {[...data].map(([name, data]) => {
            let id = [parent, name].join("-");
            return (
              <ImageInput
                key={id}
                parent={parent}
                id={id}
                name={name}
                data={data}
                onToggle={onToggle}
              />
            );
          }, this)}
        </div>
      </div>
    );
  }
}

ImageInput.proptypes = {
  // The unique string id of the image product (ex: analysis, radar, etc). It is primarily used
  // for the key property of child element, as well as label-input matching (htmlfor).
  id: PropTypes.string.isRequired,
  // The name of the product, none unique. Primarily used for translation string matching and
  // for generating a unique identifier.
  name: PropTypes.string.isRequired,
  // The actual data to be rendered. See DefaultStates.js for structure details
  data: PropTypes.object.isRequired,
  // The "name" property of the parent element. Used for className creation for styling.
  parent: PropTypes.string,
  // A callback when a checkbox is toggled
  onToggle: PropTypes.func
};

export default injectIntl(ImageInput);
